import { ProgressBar } from "./ProgressBar";

export function Footer() {
  return (
    <footer className="footer">
      <ProgressBar />
    </footer>
  );
}
